<template>
    <div>
        <autocomplete v-model="block_search" :matchingItems="matchingItems" @clickResult="clickResult" placeholder="Search blocks to add article to..."/>

      <div class="page-inline" v-bind:key="block.id" v-for="block in article.blocks">
          <p>{{block.name}}
              <span v-if="block.article_type=='auto'" style="float: right">(auto)</span>
              <a class="remove" v-if="block.article_type!='auto'" @click="removeBlock(block)"><i class="material-icons">close</i></a>
          </p>
      </div>
    </div>
</template>

<script>
    import Autocomplete from '@/components/fields/Autocomplete.vue'

    export default {
        components: {
          Autocomplete,
        },
        props: [ 'article', 'blocks'],
        data () {
            return {
                block_search: '',
                results: [],
                active: false,
            }
        },
        computed: {
        },
        methods: {
          matchingItems(text) {
            if(this.article){
                var current_block_ids = [];
                for(var i=0; i<this.article.blocks.length; i++){
                    var block = this.article.blocks[i]
                    current_block_ids.push(block.id);
                }

                this.results = [];
                for(var j=0; j<this.blocks.length; j++){
                    var block2 = this.blocks[j]
                    if(current_block_ids.indexOf(block2.id) === -1){
                      if(text.length > 0){
                          if(block2.name.toLowerCase().indexOf(text.toLowerCase()) !== -1){
                            this.results.push(block2);
                          }
                      }else {
                        this.results.push(block2);
                      }
                    }
                }
            }
            return this.results;
          },
          removeBlock (block) {

              if(this.article){
                  this.article.blocks.splice( this.article.blocks.indexOf(block), 1);
                  this.$http.delete('/articles/'+this.$route.params.id+'/blocks/'+block.id+'/').then( data => {
                      this.$store.dispatch('messages/success', this.$t('messages.article-saved'))
                  }).catch(errors => {
                      if(errors && errors.response && errors.response.data){
                          this.errors = errors.response.data
                      }
                  })
              }
          },
          clickResult (block) {
              if(this.article){
                  this.article.blocks.push(block);
                  this.block_search = ''
                  this.$http.post('/articles/'+this.$route.params.id+'/blocks/', {id: block.id}).then( data => {
                      this.$store.dispatch('messages/success', this.$t('messages.article-saved'))
                  }).catch(errors => {
                      if(errors && errors.response && errors.response.data){
                          this.errors = errors.response.data
                      }
                  })
              }
          },

        },
    }
</script>
